export default __webpack_public_path__ + "static/newsroom-header-option2-d79b65db44f2c577e2a0b9a851079a01.jpg";